export default "__VITE_ASSET__CvHpDS0C__"